import { useQuery } from 'react-query';
import { axiosInstance } from '../../libs/axiosConfig';
import { buildFilterUrl } from '../convertToUrl';
import type { FilterDto } from '../types/FilterDto';
import type { ApiResponse } from '../types/Response';

async function getWithFilter<T>(path: string, filter: FilterDto) {
	return await axiosInstance
		.get(`${path}?${buildFilterUrl(filter)}`)
		.then((res) => res.data as ApiResponse<T>);
}

export const queryWithFilter = <T>(
	path: string,
	filter: FilterDto,
	shouldQuery = true,
) => {
	return useQuery({
		queryKey: [path, filter],
		queryFn: async () => {
			const data = await getWithFilter<T>(path, filter);

			return data;
		},
		enabled: shouldQuery,
	});
};
